import { getCustomerFio } from '@/entities/customer'
import { Mortgage } from '../../types'

export function getMainCustomerFio(mortgage: Mortgage) {
  const main_customer = mortgage?.customer_applications.main_customer
  return getCustomerFio(main_customer)
}
